import * as React from "react";
const SvgCopy = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "-2 -2 22 22", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.5, d: "M11.25 14.21v1.025a2.015 2.015 0 0 1-2.015 2.015h-6.47A2.015 2.015 0 0 1 .75 15.235v-6.47c0-1.113.902-2.015 2.015-2.015h1.024" }), /* @__PURE__ */ React.createElement("rect", { width: 10.5, height: 10.5, x: 6.75, y: 0.75, stroke: "currentColor", strokeWidth: 1.5, rx: 2.207 }));
export {
  SvgCopy as default
};
//# sourceMappingURL=copy.js.map
